import { Box, Button } from "@mui/material";
import "./AIIcon.css";
const AIBlinkButton = ({ onClick, sx }) => {
  const Sparkle = ({ delay, className }) => {
    return (
      <div
        className={`sparkle ${className}`}
        style={{ animationDelay: `${delay}s` }}
      />
    );
  };
  return (
    <Button
    className="relative flex items-center justify-center"
    sx={{
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&.MuiButton-root": {
        minWidth: "0px",
      },
      marginTop: {xs: "0px" ,sm: "0px"},
      // backgroundColor: "bodyGray.main",
      // border: "1px solid",
      // borderColor: "bodyGray.main",
      
      background: " linear-gradient(90deg,rgba(253, 83, 128, 1) 0%, rgba(238, 66, 150, 1) 4%, rgba(217, 43, 180, 1) 25%, rgba(178, 0, 237, 1) 69%)",
      height: "30px",
      // boxShadow: "0 4px 7px rgba(217, 43, 180, 0.5)",
      // boxShadow: `
      //   inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
      //   0 0 0 1px hsla(0, 0%, 0%, 0.05),
      //   0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
      //   0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
      //   0 3.5px 6px hsla(0, 0%, 0%, 0.09)
      // `,
      minWidth: { xs: "50px", sm: "80px" },
      paddingX: "12px",
      gap: "8px",
    }}
    onClick={onClick}
  >
    {/* Left side - Sparkles */}
    <Box sx={{ position: "relative", width: "20px", height: "20px", }}>
      <Sparkle delay={0} className="sparkle-large absolute top-0 left-0" />
      <Sparkle delay={0.5} className="sparkle-medium absolute bottom-0 right-0" />
      <Sparkle delay={1} className="sparkle-small absolute bottom-1 left-2" />
    </Box>
  
    {/* Right side - AI Label */}
    <Box
      sx={{
        // backgroundColor: "green",
        color: "#FFF",
        borderRadius: "999px",
        fontSize: "13px",
        fontWeight: "bold",
        paddingX: 1.5,
        paddingY: 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height:"7px",
        width:"7px",
        fontFamily: "'Orbitron', sans-serif",
      }}
    >
      AI
    </Box>
  </Button>
  
  );
};

export default AIBlinkButton;
